var map = {
	"./userAdmin0.png": "TBrE",
	"./userAdmin1.png": "4d2h"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "s4/V";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/userAdmin.*\.png$
// module id = s4/V
// module chunks = 3